// src/components/not-found/not-found.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n    headingType\n    accessibility\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconTextFragment on EGDSIconText {\n    icon {\n      ...EGDSIconFragment\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    size\n    text\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    accessibility\n    decorative\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSIconTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSParagraphFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSInlineLinkFragment\n    ...EGDSSpannableTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonActionFragment on UIAction {\n    analytics {\n      linkName\n      referrerId\n    }\n\n    ... on ActivityOpenOffersModalAction {\n      activityId\n      dateRange {\n        startDate {\n          day\n          month\n          year\n        }\n        endDate {\n          day\n          month\n          year\n        }\n      }\n      dismissButtonAccessibility\n      dismissButtonAnalytics {\n        linkName\n        referrerId\n      }\n      selectedOffers {\n        offerProductNaturalKey\n      }\n      heading {\n        ...EGDSHeadingFragment\n      }\n      subHeading {\n        ...EGDSPlainTextFragment\n      }\n    }\n\n    ... on ActivityAddOfferToTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      offerNaturalKey {\n        offerProductNaturalKey\n      }\n    }\n\n    ... on ActivityRemoveOffersFromTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      offerNaturalKeys {\n        offerProductNaturalKey\n      }\n    }\n\n    ... on ActivityUpdateOfferInTripAction {\n      callbackMessages {\n        failure\n        success\n      }\n      newOfferNaturalKey {\n        offerProductNaturalKey\n      }\n      oldOfferNaturalKey {\n        offerProductNaturalKey\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    accessibility\n    disabled\n    action {\n      ...EGDSButtonActionFragment\n    }\n    icon {\n      description\n      id\n      title\n    }\n  }\n\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  query NotFoundQuery($context: ContextInput!, $activityId: String!, $dateRange: ActivityDateRangeInput, $destination: ActivityDestinationInput) {\n    activityInfo(context: $context, activityId: $activityId, dateRange: $dateRange, destination: $destination) {\n      notFound {\n        graphic {\n          ...EGDSGraphicFragment\n        }\n        primary {\n          ...EGDSHeadingFragment\n        }\n        secondaries {\n          ...EGDSTextFragment\n        }\n        backButton {\n          ...EGDSButtonFragment\n        }\n        backButtonAction {\n          accessibilityText\n          analytics {\n            linkName\n            referrerId\n          }\n          linkTagUrl\n          opensInNewTab\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
import React16 from "react";
import { gql as gql17, useQuery } from "@apollo/client";
// ../internal/src/components/egds-button/egds-button.tsx
import React15 from "react";
import { gql as gql16 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkOverlayButton, UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
// ../internal/src/components/egds-button/egds-button-action.ts
import { gql as gql15 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-heading.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var _obj;
// ../internal/src/components/egds-text/__private/heading-map.ts
var headingTagMapper = (_obj = {}, _define_property(_obj, "H1" /* H1 */, "h1"), _define_property(_obj, "H2" /* H2 */, "h2"), _define_property(_obj, "H3" /* H3 */, "h3"), _define_property(_obj, "H4" /* H4 */, "h4"), _define_property(_obj, "H5" /* H5 */, "h5"), _define_property(_obj, "H6" /* H6 */, "h6"), _define_property(_obj, "H7" /* H7 */, "h6"), _define_property(_obj, "H8" /* H8 */, "h6"), _obj);
// ../internal/src/components/egds-text/egds-heading.tsx
var fragment = gql(_templateObject());
var EGDSHeading = function (param) {
  var className = param.className,
    align = param.align,
    size = param.size,
    tag = param.tag,
    data = param.data,
    tabIndex = param.tabIndex;
  var headingType = data.headingType,
    text = data.text,
    accessibility = data.accessibility;
  var headingTag = tag !== null && tag !== void 0 ? tag : headingType ? headingTagMapper[headingType] : void 0;
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(UitkHeading, {
    className: className,
    align: align,
    tag: tag !== null && tag !== void 0 ? tag : headingTag,
    size: size,
    tabIndex: tabIndex,
    "aria-hidden": accessibility !== null
  }, text), accessibility && /* @__PURE__ */React.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSHeading.fragment = fragment;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var _obj1;
// ../internal/src/components/egds-text/__private/paragraph-style-size-map.ts
var paragraphStyleSizeMap = (_obj1 = {}, _define_property(_obj1, "P1" /* P1 */, 1), _define_property(_obj1, "P2" /* P2 */, 2), _define_property(_obj1, "P3" /* P3 */, 3), _obj1);
// ../internal/src/components/egds-text/egds-paragraph.tsx
var fragment2 = gql2(_templateObject1());
var EGDSParagraph = function (param) {
  var className = param.className,
    data = param.data;
  var text = data.text,
    style = data.style;
  return /* @__PURE__ */React2.createElement(UitkParagraph, {
    className: className,
    size: paragraphStyleSizeMap[style]
  }, text);
};
EGDSParagraph.fragment = fragment2;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var __EGDSIconFragment = gql3(_templateObject2());
var _data_title, _data_theme;
var EGDSIcon = function (param) {
  var className = param.className,
    data = param.data;
  var _data;
  return /* @__PURE__ */React3.createElement(UitkIcon, {
    className: className,
    description: data.description,
    id: Math.random().toString(),
    name: data.id,
    size: data.size ? UitkIconSize[data.size] : void 0,
    title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: (_data_theme = (_data = data) === null || _data === void 0 ? void 0 : _data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
    shadow: Boolean(data.withBackground)
  });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var __EGDSMarkFragment = gql4(_templateObject3());
var EGDSMark = function (param) {
  var className = param.className,
    data = param.data;
  var _data_url;
  return /* @__PURE__ */React4.createElement(UitkMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? UitkMarkSize[data.markSize] : void 0,
    url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
  });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
var __EGDSGraphicFragment = gql5(_templateObject4(), EGDSIcon.fragment, EGDSMark.fragment);
var EGDSGraphic = function (param) {
  var className = param.className,
    data = param.data;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React5.createElement(EGDSIcon, {
        className: className,
        data: data
      });
    case "Mark":
      return /* @__PURE__ */React5.createElement(EGDSMark, {
        className: className,
        data: data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
var _obj2;
// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = (_obj2 = {}, _define_property(_obj2, "SMALL" /* SMALL */, "small"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "LARGE" /* LARGE */, "large"), _obj2);
var _obj3;
var UILinkTargetMap = (_obj3 = {}, _define_property(_obj3, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj3, "INTERNAL" /* INTERNAL */, "_self"), _obj3);
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql6(_templateObject5(), EGDSIcon.fragment);
var IconPlacement = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    iconPositionToMatch = param.iconPositionToMatch;
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React6.createElement(EGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    useRelativePath = _param_data_action.useRelativePath,
    disabled = _param_data.disabled,
    iconPosition = _param_data.iconPosition,
    standardLinkIcon = _param_data.standardLinkIcon,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker();
  var onClick = React6.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  var getPath = React6.useCallback(function () {
    switch (resource.__typename) {
      case "HttpURI":
        return useRelativePath ? resource.relativePath : resource.value;
      default:
        return resource.value;
    }
  }, [resource, useRelativePath]);
  return /* @__PURE__ */React6.createElement(UitkLink, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline: inline,
    disabled: disabled,
    align: align
  }, /* @__PURE__ */React6.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React6.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React6.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React6.createElement(UitkText, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-text.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment4 = gql7(_templateObject6(), EGDSGraphic.fragment);
var graphicMargin = {
  inlineend: "one"
};
var textMargin = {
  inlineend: "one"
};
var EGDSGraphicText = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var graphic = data.graphic,
    text = data.text;
  return /* @__PURE__ */React7.createElement(UitkLayoutFlex, {
    className: className
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React7.createElement(UitkSpacing, {
    margin: graphicMargin
  }, /* @__PURE__ */React7.createElement(EGDSGraphic, {
    data: graphic
  }))), /* @__PURE__ */React7.createElement(UitkLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React7.createElement(UitkSpacing, {
    margin: textMargin
  }, /* @__PURE__ */React7.createElement(UitkText2, {
    size: size
  }, text))));
};
EGDSGraphicText.fragment = fragment4;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-text/egds-icon-text.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment5 = gql8(_templateObject7(), EGDSIcon.fragment);
var iconMargin = {
  inlineend: "one"
};
var textMargin2 = {
  inlineend: "one"
};
var EGDSIconText = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data;
  var icon = data.icon,
    text = data.text;
  return /* @__PURE__ */React8.createElement(UitkLayoutFlex2, {
    className: className
  }, /* @__PURE__ */React8.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React8.createElement(UitkSpacing2, {
    margin: iconMargin
  }, /* @__PURE__ */React8.createElement(EGDSIcon, {
    data: icon
  }))), /* @__PURE__ */React8.createElement(UitkLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React8.createElement(UitkSpacing2, {
    margin: textMargin2
  }, /* @__PURE__ */React8.createElement(UitkText3, {
    size: size
  }, text))));
};
EGDSIconText.fragment = fragment5;
EGDSIconText.displayName = "EGDSIconText";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
var fragment6 = gql9(_templateObject8());
var EGDSInlineLink = function (param) {
  var className = param.className,
    _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    disabled = _param_data.disabled,
    size = _param_data.size,
    text = _param_data.text;
  var clickTracker = useClickTracker2();
  var onClick = React9.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React9.createElement(UitkLink2, {
    className: className,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    disabled: disabled,
    inline: true
  }, /* @__PURE__ */React9.createElement("a", {
    href: resource.value,
    target: UILinkTargetMap[target]
  }, text, accessibility && /* @__PURE__ */React9.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSInlineLink.fragment = fragment6;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment7 = gql10(_templateObject9());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    size = param.size,
    theme = param.theme,
    data = param.data;
  var text = data.text;
  return /* @__PURE__ */React10.createElement(UitkText4, {
    whiteSpace: "pre-line",
    className: className,
    align: align,
    size: size,
    inline: inline,
    theme: theme
  }, text);
};
EGDSPlainText.fragment = fragment7;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkText as UitkText6 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
var _obj4;
// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = (_obj4 = {}, _define_property(_obj4, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj4, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj4, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj4, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj4, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj4, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj4, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj4, "EMPHASIS" /* EMPHASIS */, "emphasis"), _obj4);
var _obj5;
var UitkTextThemeMapper = (_obj5 = {}, _define_property(_obj5, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj5, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj5, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj5, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj5, "DEFAULT" /* DEFAULT */, "default"), _obj5);
var _obj6;
// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj6 = {}, _define_property(_obj6, "BOLD" /* BOLD */, "bold"), _define_property(_obj6, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj6, "REGULAR" /* REGULAR */, "regular"), _obj6);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment8 = gql11(_templateObject10());
var EGDSStylizedText = function (param) {
  var className = param.className,
    inline = param.inline,
    align = param.align,
    size = param.size,
    data = param.data;
  var text = data.text,
    theme = data.theme,
    weight = data.weight,
    accessibility = data.accessibility,
    decorative = data.decorative;
  var themeProps = theme ? textThemeMapper[theme] : void 0;
  var weightProps = weight ? textWeightMapper[weight] : void 0;
  var RenderText = function () {
    return /* @__PURE__ */React11.createElement(React11.Fragment, null, /* @__PURE__ */React11.createElement(UitkText5, {
      className: className,
      align: align,
      inline: inline,
      size: size,
      theme: themeProps,
      weight: weightProps,
      "aria-hidden": accessibility !== null
    }, text), accessibility && /* @__PURE__ */React11.createElement("span", {
      className: "is-visually-hidden"
    }, accessibility));
  };
  switch (decorative) {
    case "LINE_THROUGH" /* LINE_THROUGH */:
      return /* @__PURE__ */React11.createElement("s", null, /* @__PURE__ */React11.createElement(RenderText, null));
    default:
      return /* @__PURE__ */React11.createElement(RenderText, null);
  }
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment9 = gql12(_templateObject11(), EGDSStylizedText.fragment, EGDSGraphicText.fragment, EGDSPlainText.fragment);
var EGDSSpannableTextContent = function (param) {
  var className = param.className,
    size = param.size,
    align = param.align,
    theme = param.theme,
    data = param.data;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React12.createElement(EGDSStylizedText, {
        className: className,
        data: data,
        size: size,
        inline: true
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React12.createElement(EGDSGraphicText, {
        className: className,
        data: data,
        size: size
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React12.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        align: align,
        inline: true,
        theme: theme
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment10 = gql13(_templateObject12(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function (props) {
  var _data_contents, _data, _data_inlineContent, _data1, _data_inlineContent1, _data2;
  var align = props.align,
    headingSize = props.headingSize,
    data = props.data,
    theme = props.theme,
    styleProps = _object_without_properties(props, ["align", "headingSize", "data", "theme"]);
  if (((_data = data) === null || _data === void 0 ? void 0 : (_data_contents = _data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_inlineContent = _data1.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
    return /* @__PURE__ */React13.createElement(UitkText6, _object_spread_props(_object_spread({}, styleProps), {
      inline: true,
      align: align,
      theme: theme
    }), data.text);
  }
  if ((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_inlineContent1 = _data2.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
    return /* @__PURE__ */React13.createElement(React13.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React13.createElement(React13.Fragment, null, /* @__PURE__ */React13.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
        align: align,
        data: item
      }, styleProps), {
        key: "spannable-item-".concat(index),
        theme: theme
      })), " ");
    }));
  }
  return /* @__PURE__ */React13.createElement(React13.Fragment, null, data.contents.map(function (item, index) {
    return /* @__PURE__ */React13.createElement(React13.Fragment, {
      key: "spannable-item-".concat(index)
    }, /* @__PURE__ */React13.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
      data: item
    }, styleProps), {
      headingSize: headingSize,
      theme: theme
    })), " ");
  }));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment11 = gql14(_templateObject13(), EGDSHeading.fragment, EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSIconText.fragment, EGDSGraphicText.fragment, EGDSParagraph.fragment, EGDSStandardLink.fragment, EGDSInlineLink.fragment, EGDSSpannableText.fragment);
var EGDSText = function (param) {
  var className = param.className,
    headingAlign = param.headingAlign,
    headingSize = param.headingSize,
    headingTag = param.headingTag,
    textAlign = param.textAlign,
    textSize = param.textSize,
    align = param.align,
    inline = param.inline,
    tabIndex = param.tabIndex,
    theme = param.theme,
    data = param.data;
  var _data;
  switch ((_data = data) === null || _data === void 0 ? void 0 : _data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React14.createElement(EGDSHeading, {
        className: className,
        align: headingAlign,
        size: headingSize,
        tag: headingTag,
        data: data,
        tabIndex: tabIndex
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React14.createElement(EGDSPlainText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data,
        inline: inline,
        theme: theme
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React14.createElement(EGDSStylizedText, {
        className: className,
        align: textAlign,
        size: textSize,
        data: data,
        inline: inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React14.createElement(EGDSGraphicText, {
        className: className,
        size: textSize,
        data: data
      });
    case "EGDSIconText":
      return /* @__PURE__ */React14.createElement(EGDSIconText, {
        className: className,
        size: textSize,
        data: data
      });
    case "EGDSParagraph":
      return /* @__PURE__ */React14.createElement(EGDSParagraph, {
        className: className,
        data: data
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React14.createElement(EGDSStandardLink, {
        className: className,
        data: data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React14.createElement(EGDSInlineLink, {
        className: className,
        data: data
      });
    case "EGDSSpannableText":
      return /* @__PURE__ */React14.createElement(EGDSSpannableText, {
        className: className,
        size: textSize,
        headingSize: headingSize,
        data: data,
        align: align,
        theme: theme
      });
    default:
      return null;
  }
};
EGDSText.fragment = fragment11;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/egds-button/egds-button-action.ts
var __EGDSButtonActionFragment = gql15(_templateObject14(), EGDSHeading.fragment, EGDSPlainText.fragment);
// ../internal/src/components/egds-button/egds-button.tsx
var _Fragment = gql16(_templateObject15(), __EGDSButtonActionFragment);
var EGDSButton = function (param) {
  var analytics = param.analytics,
    className = param.className,
    domRef = param.domRef,
    href = param.href,
    isFullWidth = param.isFullWidth,
    onClickHandler = param.onClickHandler,
    size = param.size,
    data = param.data;
  var __typename = data.__typename,
    accessibility = data.accessibility,
    action = data.action,
    primary = data.primary,
    disabled = data.disabled,
    icon = data.icon;
  var clickTracker = useClickTracker3();
  var analyticsButton = action ? {
    description: action.analytics.linkName,
    id: action.analytics.referrerId,
    callback: function (referrerId, linkName) {
      clickTracker(referrerId, linkName);
    }
  } : void 0;
  var handleOnClick = React15.useCallback(function () {
    var _onClickHandler;
    (_onClickHandler = onClickHandler) === null || _onClickHandler === void 0 ? void 0 : _onClickHandler();
  }, [onClickHandler]);
  if (!primary) {
    return null;
  }
  var buttonProps = {
    analytics: analytics || analyticsButton,
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
    className: className,
    disabled: disabled,
    href: href,
    isFullWidth: isFullWidth,
    onClick: handleOnClick,
    size: size,
    domRef: domRef
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React15.createElement(UitkPrimaryButton, _object_spread({}, buttonProps), primary);
    case "UISecondaryButton":
      return /* @__PURE__ */React15.createElement(UitkSecondaryButton, _object_spread({}, buttonProps), primary);
    case "UITertiaryButton":
      return /* @__PURE__ */React15.createElement(UitkTertiaryButton, _object_spread({}, buttonProps), primary);
    case "EGDSOverlayButton":
      var _icon;
      var _icon_id;
      return /* @__PURE__ */React15.createElement(UitkOverlayButton, _object_spread({}, buttonProps), icon && /* @__PURE__ */React15.createElement(UitkIcon2, {
        name: (_icon_id = (_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) !== null && _icon_id !== void 0 ? _icon_id : ""
      }), primary);
    default:
      return null;
  }
};
EGDSButton.fragment = _Fragment;
EGDSButton.displayName = "EGDSButton";
// src/components/not-found/not-found.tsx
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkEmptyState, UitkEmptyStateActionArea } from "uitk-react-empty-state";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var __Query = gql17(_templateObject16(), EGDSButton.fragment, EGDSGraphic.fragment, EGDSHeading.fragment, EGDSText.fragment);
var NotFound = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr,
    className = param.className;
  var _data;
  var context = useBexApi().context;
  var trackClick = useClickTracker4();
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var notFound = (_data = data) === null || _data === void 0 ? void 0 : _data.activityInfo.notFound;
  if (loading || error || !notFound) {
    return null;
  }
  var primary = notFound.primary,
    secondaries = notFound.secondaries,
    graphic = notFound.graphic,
    backButton = notFound.backButton,
    backButtonAction = notFound.backButtonAction;
  var analytics = backButtonAction.analytics ? {
    description: backButtonAction.analytics.linkName,
    id: backButtonAction.analytics.referrerId,
    callback: function (referrerId, linkName) {
      trackClick(referrerId, linkName);
    }
  } : void 0;
  var _backButtonAction_linkTagUrl;
  return /* @__PURE__ */React16.createElement("div", {
    className: className
  }, /* @__PURE__ */React16.createElement(UitkEmptyState, {
    fullscreen: true
  }, graphic && /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockend: "four"
    }
  }, /* @__PURE__ */React16.createElement(EGDSGraphic, {
    data: graphic
  })), /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React16.createElement(EGDSHeading, {
    size: 5,
    data: primary
  })), /* @__PURE__ */React16.createElement(UitkSpacing3, {
    margin: {
      blockend: "twelve"
    }
  }, secondaries.map(function (textContent, index) {
    return /* @__PURE__ */React16.createElement(EGDSText, {
      data: textContent,
      key: index
    });
  })), /* @__PURE__ */React16.createElement(UitkEmptyStateActionArea, null, /* @__PURE__ */React16.createElement(EGDSButton, {
    data: backButton,
    analytics: analytics,
    href: (_backButtonAction_linkTagUrl = backButtonAction.linkTagUrl) !== null && _backButtonAction_linkTagUrl !== void 0 ? _backButtonAction_linkTagUrl : void 0
  }))));
};
NotFound.displayName = "sharedui-NotFound";
export { NotFound };